import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ContentContainer } from '@/components/layout';
import { Text, Headline } from '@/components/typography';
interface SourceListProps {
  title: string;
  anchorKey?: string;
  text: string;
  items: JSX.Element;
}
export const SourceList = t0 => {
  const $ = _c(9);
  const {
    title,
    anchorKey,
    text,
    items
  } = t0;
  let t1;
  if ($[0] !== anchorKey || $[1] !== title) {
    t1 = <Headline as="h3" variant="h4" anchorKey={anchorKey} className="mb-3 text-center lg:mb-4">{title}</Headline>;
    $[0] = anchorKey;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== text) {
    t2 = <Text variant="p2" className="mb-6 text-center text-gray-800 lg:mb-12">{text}</Text>;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== items || $[6] !== t1 || $[7] !== t2) {
    t3 = <ContentContainer>{t1}{t2}{items}</ContentContainer>;
    $[5] = items;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};